// stores/auth.ts - Tenant destekli versiyon
//@ts-nocheck
import { defineStore } from 'pinia'
import router from '../router'
import axios_public from '@/axios/axios_public'
import * as sabitler from '../sabitler'
import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode'

// Token Configuration - Basit ve temiz
const TOKEN_CONFIG = {
    ACCESS_TOKEN_DURATION: 60 * 24 * 60 * 60, // 60 gün
    REFRESH_INTERVAL: 7 * 24 * 60 * 60, // 7 günde bir yenile
    REFRESH_TOKEN_DURATION: 90, // 90 gün
    isDevelopment: process.env.NODE_ENV === 'development',
    enableLogs: false,
    disableMFA: true // true = MFA kapalı, false = MFA açık
} as const

// Logger Configuration
const Logger = {
    shouldLog: () => TOKEN_CONFIG.isDevelopment && TOKEN_CONFIG.enableLogs,
    log: (...args: any[]) => {
        if (Logger.shouldLog()) console.log(...args)
    },
    error: (...args: any[]) => {
        if (Logger.shouldLog()) console.error(...args)
    },
    info: (...args: any[]) => {
        if (Logger.shouldLog()) console.info(...args)
    },
    warn: (...args: any[]) => {
        if (Logger.shouldLog()) console.warn(...args)
    },
    group: (label: string) => {
        if (Logger.shouldLog()) console.group(label)
    },
    groupEnd: () => {
        if (Logger.shouldLog()) console.groupEnd()
    }
}

// Interfaces
interface JWTPayload {
    exp: number
    iat: number
    jti: string
    token_type: string
    user_id: number
}

interface LoginData {
    username: string
    password: string
    rememberMe: boolean
    isUser?: boolean
}

// Tenant Interface - YENİ
interface Tenant {
    id: number
    name: string
    name_top: string
    phone: string
    email: string | null
    schema_name: string
}

interface User {
    id: string
    username: string
    email: string
    first_name: string
    last_name: string
    role: string
    role_str: string
    conn: string
    avatar?: string
}

interface AuthState {
    accessToken: string
    refreshToken: string
    user: User | null
    tenant: Tenant | null // YENİ - Tenant bilgisi
    allowedLinks: string[]
    login_error: string | false
    save_loading: boolean
    refreshInterval: ReturnType<typeof setInterval> | null
    logInterval: ReturnType<typeof setInterval> | null
    tokenExpiryTime: Date | null
    lastTokenRefresh: Date | null
    mfaStep: 'login' | 'method' | 'verify' | 'complete'
    mfaSessionId: string | null
    selectedMethod: 'email' | 'sms' | null,
    referenceId: string | null,
    verificationOptions: {
        email: Array<{id: number, name: string}>,
        phone: Array<{id: number, name: string}>
    } | null
    selectedVerificationId: number | null,
    //  Hesap doğrulama için ek state'ler
    verifyStep: 'none' | 'required' | 'phone' | 'add-phone' | 'complete'  // 🔴 'add-phone' eklendi
    pendingUserId: number | null
    pendingUserEmail: string | null
    pendingUserPhone: string | null  // 🆕 Backend'den gelen telefon
    newPhoneNumber: string | null    // 🆕 Kullanıcının gireceği yeni telefon
    emailVerified: boolean
    phoneVerified: boolean
}

interface TokenResponse {
    access: string
    refresh: string
    user_id: string
    username: string
    email: string
    first_name: string
    last_name: string
    role: string
    role_str: string
    conn: string
    allowed_links: string[]
    tenant?: Tenant // YENİ - Opsiyonel tenant
    mfa_required?: boolean
    avatar?: string 
}



export const useAuthStore = defineStore('auth', {
    state: (): AuthState => ({
        accessToken: '',
        refreshToken: '',
        user: null,
        tenant: null, // YENİ
        allowedLinks: [],
        login_error: false,
        save_loading: false,
        refreshInterval: null,
        logInterval: null,
        tokenExpiryTime: null,
        lastTokenRefresh: null,
        mfaStep: 'login',
        mfaSessionId: null,
        selectedMethod: null,
        referenceId: null,
        verificationOptions: null,
        selectedVerificationId: null,
        verifyStep: 'none',
        pendingUserId: null,
        pendingUserEmail: null,
        pendingUserPhone: null,
        newPhoneNumber: null,  
        emailVerified: false,
        phoneVerified: false
    }),

    getters: {
        isAuth: (state) => state.accessToken !== '',
        currentUser: (state) => state.user,
        currentTenant: (state) => state.tenant, // YENİ - Tenant getter
        getTokenExpiryTime: (state) => state.tokenExpiryTime,
        isMFAEnabled: () => !TOKEN_CONFIG.disableMFA
    },

    actions: {
        handleSessionError(error: any) {
            if (error.response?.data?.error === "Geçersiz veya süresi dolmuş oturum" ||
                error.response?.data?.detail === "Geçersiz veya süresi dolmuş oturum") {
                
                this.mfaStep = 'login'
                this.mfaSessionId = null
                this.selectedMethod = null
                this.referenceId = null
                this.selectedVerificationId = null
                
                this.login_error = "Doğrulama süresi doldu. Lütfen tekrar giriş yapın."
                
                Logger.warn('Oturum süresi doldu, login ekranına yönlendiriliyor')
                return true
            }
            return false
        },
        
        stopAllIntervals() {
            if (this.refreshInterval) {
                clearInterval(this.refreshInterval)
                this.refreshInterval = null
            }
            if (this.logInterval) {
                clearInterval(this.logInterval)
                this.logInterval = null
            }
            Logger.log('Tüm interval\'lar durduruldu')
        },

        getTokenRemainingTime(token: string): number {
            try {
                const decoded = jwtDecode<JWTPayload>(token)
                const expirationTime = decoded.exp * 1000
                const currentTime = Date.now()
                return Math.max(0, expirationTime - currentTime)
            } catch {
                return 0
            }
        },

        startTokenRefreshInterval() {
            this.stopAllIntervals()

            const remainingTime = this.getTokenRemainingTime(this.accessToken)
            Logger.group('Token Yenileme Başlatıldı')
            Logger.log('Token için kalan süre (ms):', remainingTime)

            this.tokenExpiryTime = new Date(Date.now() + remainingTime)
            Logger.log('Token son kullanma:', this.tokenExpiryTime)
            Logger.groupEnd()

            this.logInterval = setInterval(() => {
                if (this.tokenExpiryTime) {
                    const now = new Date()
                    const timeLeft = Math.max(0, this.tokenExpiryTime.getTime() - now.getTime())
                    const seconds = Math.floor(timeLeft / 1000)
                    Logger.log(`Token süresi: ${seconds} saniye`)
                }
            }, 1000)

            this.refreshInterval = setInterval(async () => {
                Logger.group('Token Yenileme İşlemi')
                const success = await this.refreshTokens()

                if (success) {
                    Logger.info('✅ Token başarıyla yenilendi')
                    const newRemainingTime = this.getTokenRemainingTime(this.accessToken)
                    this.tokenExpiryTime = new Date(Date.now() + newRemainingTime)
                    Logger.log('Yeni token son kullanma:', this.tokenExpiryTime)
                } else {
                    Logger.error('❌ Token yenileme başarısız! Timer durduruluyor.')
                    this.stopAllIntervals()
                }
                Logger.groupEnd()
            }, TOKEN_CONFIG.REFRESH_INTERVAL * 1000)
        },

        async login(authData: LoginData) {
            this.login_error = false
            this.save_loading = true

            try {
                Logger.group('Login İşlemi')
                
                // 🆕 İlk önce initial-login kontrolü yap
                const initialResponse = await axios_public.post(
                    `${sabitler.apiBaseURL}login/initial/`,
                    {
                        username: authData.username,
                        password: authData.password
                    }
                )
                
                // 🆕 Doğrulama tamamlanmış mı kontrol et
                if (initialResponse.data.verified) {
                    Logger.info('Kullanıcı doğrulanmış, normal token alınıyor')
                    
                    // Normal token endpoint'ine git
                    if (TOKEN_CONFIG.disableMFA) {
                        const response = await axios_public.post(
                            `${sabitler.apiBaseURL}token`,
                            {
                                username: authData.username,
                                password: authData.password,
                                rememberMe: authData.rememberMe
                            }
                        )
                        
                        await this.handleSuccessfulLogin(response.data, authData.rememberMe)
                        Logger.info('Direkt giriş başarılı')
                    } else {
                        // MFA akışı (mevcut kod)
                        Logger.info('MFA açık, ilk adım başlatılıyor')
                        const response = await axios_public.post(
                            `${sabitler.apiBaseURL}login/initial/`,
                            {
                                username: authData.username,
                                password: authData.password,
                                rememberMe: authData.rememberMe
                            }
                        )

                        this.mfaSessionId = response.data.mfa_session_id
                        this.mfaStep = 'method'
                        Logger.info('İlk giriş başarılı, doğrulama adımına geçiliyor')
                    }
                }

            } catch (error: any) {
                Logger.error('Login hatası:', error)

                // 🆕 Doğrulama gerekiyor mu kontrol et
                if (error.response?.status === 400 && error.response?.data?.requires_verification) {
                    const data = error.response.data
                    
                    this.pendingUserId = data.user_id
                    this.pendingUserEmail = data.email
                    this.pendingUserPhone = data.phone
                    this.emailVerified = data.email_verified
                    this.phoneVerified = data.phone_verified
                    this.verifyStep = 'required'
                    
                    Logger.warn('Kullanıcı doğrulama gerekiyor')
                    router.push('/auth/verify-account')
                    return
                }

                this.login_error = error.response?.data?.detail || 'Kullanıcı adı veya parola hatalı.'
            } finally {
                this.save_loading = false
                Logger.groupEnd()
            }
        },

        async fetchMfaVerifyList() {
            this.login_error = false
            this.save_loading = true
        
            try {
                Logger.group('MFA Doğrulama Listesi Alınıyor')
                const response = await axios_public.post(
                    `${sabitler.apiBaseURL}login/mfa-verify-list/`,
                    {
                        mfa_session_id: this.mfaSessionId
                    }
                )
        
                this.verificationOptions = response.data
                Logger.info('Doğrulama seçenekleri alındı:', this.verificationOptions)
                return true
        
            } catch (error: any) {
                console.log(error)
                if (this.handleSessionError(error)) {
                    return false
                }
                Logger.error('MFA doğrulama listesi hatası:', error)
                this.login_error = error.response?.data?.detail || 'Doğrulama seçenekleri alınamadı'
                return false
            } finally {
                this.save_loading = false
                Logger.groupEnd()
            }
        },

        async selectMFAMethod(method: 'email' | 'sms', verificationId?: number) {
            this.login_error = false
            this.save_loading = true
        
            try {
                Logger.group('MFA Metod Seçimi')
                
                if (verificationId === undefined) {
                    this.selectedMethod = method
                    await this.fetchMfaVerifyList()
                    return true
                }
                
                this.selectedVerificationId = verificationId
                
                const response = await axios_public.post(
                    `${sabitler.apiBaseURL}login/select-method/`,
                    {
                        verification_type: method,
                        mfa_session_id: this.mfaSessionId,
                        verification_id: verificationId
                    }
                )
        
                this.referenceId = response.data.reference_id || null
                this.mfaStep = 'verify'
                Logger.info('Doğrulama yöntemi seçildi')
                return true
        
            } catch (error: any) {
                console.log(error)
                if (this.handleSessionError(error)) {
                    return false
                }
                Logger.error('MFA yöntem seçim hatası:', error)
                this.login_error = error.response?.data?.detail || 'Doğrulama yöntemi seçilemedi'
                return false
            } finally {
                this.save_loading = false
                Logger.groupEnd()
            }
        },

        async verifyMFACode(code: string) {
            this.login_error = false
            this.save_loading = true

            try {
                Logger.group('MFA Kod Doğrulama')
                const response = await axios_public.post(
                    `${sabitler.apiBaseURL}login/verify-code/`,
                    {
                        code,
                        verification_type: this.selectedMethod,
                        mfa_session_id: this.mfaSessionId
                    }
                )

                await this.handleSuccessfulLogin(response.data, false)

                this.mfaStep = 'complete'
                this.mfaSessionId = null
                this.selectedMethod = null

                Logger.info('MFA doğrulaması başarılı, giriş tamamlandı')

            } catch (error: any) {
                Logger.error('MFA doğrulama hatası:', error)
                if (this.handleSessionError(error)) {
                    return false
                }
            
                this.login_error = error.response?.data?.detail || 'Doğrulama kodu hatalı'
            } finally {
                this.save_loading = false
                Logger.groupEnd()
            }
        },

        async resendVerificationCode() {
            this.login_error = false
            this.save_loading = true
        
            try {
                Logger.group('Kod Yeniden Gönderme')
                
                const response = await axios_public.post(
                    `${sabitler.apiBaseURL}login/resend-code/`,
                    {
                        mfa_session_id: this.mfaSessionId,
                        verification_type: this.selectedMethod,
                        verification_id: this.selectedVerificationId
                    }
                )
                
                if (response.data.reference_id) {
                    this.referenceId = response.data.reference_id
                } else {
                    this.referenceId = null
                }
                
                Logger.info('Yeni kod gönderildi')
                return true
        
            } catch (error: any) {
                console.log(error)
                if (this.handleSessionError(error)) {
                    return false
                }
                Logger.error('Kod gönderme hatası:', error)
                this.login_error = error.response?.data?.detail || 'Kod gönderilemedi'
                return false
            } finally {
                this.save_loading = false
                Logger.groupEnd()
            }
        },

        async handleSuccessfulLogin(data: TokenResponse, rememberMe: boolean = false) {
            const userObject = {
                id: data.user_id,
                username: data.username,
                email: data.email,
                first_name: data.first_name,
                last_name: data.last_name,
                role: data.role,
                role_str: data.role_str,
                conn: data.conn,
                avatar: data.avatar 
            }

            // Store state güncelleme
            this.accessToken = data.access
            this.refreshToken = data.refresh
            this.allowedLinks = data.allowed_links
            this.user = userObject
            this.tenant = data.tenant || null // YENİ - Tenant'ı state'e ekle

            // Cookie ayarları
            const currentDomain = window.location.hostname
            const cookieOptions = {
                secure: !TOKEN_CONFIG.isDevelopment,
                sameSite: 'Lax' as const,
                path: '/',
                domain: currentDomain
            }

            console.log('=== COOKIE AYARLARI ===')
            console.log('rememberMe değeri:', rememberMe)
            console.log('accessDays hesaplanan:', rememberMe ? (TOKEN_CONFIG.ACCESS_TOKEN_DURATION / (24 * 60 * 60)) : 1)
            console.log('refreshDays hesaplanan:', rememberMe ? TOKEN_CONFIG.REFRESH_TOKEN_DURATION : 7)

            const accessDays = rememberMe ? (TOKEN_CONFIG.ACCESS_TOKEN_DURATION / (24 * 60 * 60)) : 1
            const refreshDays = rememberMe ? TOKEN_CONFIG.REFRESH_TOKEN_DURATION : 7

            console.log('Cookie süreleri - Access:', accessDays, 'gün, Refresh:', refreshDays, 'gün')

            // Access token
            Cookies.set('accessToken', data.access, {
                ...cookieOptions,
                expires: accessDays
            })

            // Refresh token
            Cookies.set('refreshToken', data.refresh, {
                ...cookieOptions,
                expires: refreshDays
            })

            // Allowed links
            Cookies.set('allowedLinks', JSON.stringify(data.allowed_links), cookieOptions)

            // Local storage güncelleme
            localStorage.setItem('user', JSON.stringify(userObject))
            localStorage.setItem('allowedLinks', JSON.stringify(data.allowed_links))
            
            // YENİ - Tenant varsa kaydet
            if (data.tenant) {
                localStorage.setItem('tenant', JSON.stringify(data.tenant))
            }

            this.lastTokenRefresh = new Date()
            this.startTokenRefreshInterval()

            console.log('=== LOGIN SUCCESS DEBUG ===')
            console.log('RememberMe parametresi:', rememberMe)
            console.log('TOKEN_CONFIG.ACCESS_TOKEN_DURATION:', TOKEN_CONFIG.ACCESS_TOKEN_DURATION)
            console.log('TOKEN_CONFIG.REFRESH_TOKEN_DURATION:', TOKEN_CONFIG.REFRESH_TOKEN_DURATION)

            router.push('/')
        },
        // Avatar güncelleme action
        async updateUserAvatar(avatarUrl: string | null) {
            if (this.user) {
                this.user.avatar = avatarUrl  // ✅ null olabilir
                localStorage.setItem('user', JSON.stringify(this.user))
                Logger.info('Avatar güncellendi:', avatarUrl || 'null (blank-avatar gösterilecek)')
            }
        },

        async refreshTokens() {
            try {
                const refreshToken = Cookies.get('refreshToken')

                if (!refreshToken) {
                    Logger.error('Refresh token bulunamadı')
                    throw new Error('Refresh token bulunamadı')
                }

                Logger.log('Refresh token ile yeni token alınıyor...')
                const response = await axios_public.post<{access: string}>(
                    `${sabitler.apiBaseURL}token/refresh`,
                    { refresh: refreshToken }
                )

                this.accessToken = response.data.access
                
                const accessDays = TOKEN_CONFIG.ACCESS_TOKEN_DURATION / (24 * 60 * 60)
                
                Cookies.set('accessToken', response.data.access, {
                    secure: !TOKEN_CONFIG.isDevelopment,
                    sameSite: 'Lax',
                    expires: accessDays,
                    path: '/',
                    domain: window.location.hostname
                })

                Logger.info('Yeni access token alındı ve kaydedildi')
                return true
            } catch (error) {
                Logger.error('Token yenileme hatası:', error)
                this.logout()
                return false
            }
        },

        logout() {
            Logger.group('Logout İşlemi')
            
            this.stopAllIntervals()

            // State temizle
            this.accessToken = ''
            this.refreshToken = ''
            this.user = null
            this.tenant = null // YENİ - Tenant'ı temizle
            this.allowedLinks = []
            
            // MFA state'lerini temizle
            this.mfaStep = 'login'
            this.mfaSessionId = null
            this.selectedMethod = null

            // Cookie'leri temizle
            Cookies.remove('accessToken')
            Cookies.remove('refreshToken')
            Cookies.remove('allowedLinks')

            // LocalStorage temizle
            localStorage.removeItem('user')
            localStorage.removeItem('tenant') // YENİ - Tenant'ı temizle
            localStorage.removeItem('allowedLinks')

            Logger.log('Logout tamamlandı')
            Logger.groupEnd()
            
            router.push('/auth/login')
            window.location.href = '/';
        },

        async fetchTenantInfo() {
                    try {
                        Logger.log('Tenant bilgisi backend\'den alınıyor...')
                        
                        // Token ile istek atmak için axios_public yerine fetch kullan
                        const response = await fetch(`${sabitler.apiBaseURL}user/tenant-info`, {
                            method: 'GET',
                            headers: {
                                'Authorization': `Bearer ${this.accessToken}`,
                                'Content-Type': 'application/json'
                            }
                        })
                        
                        if (!response.ok) {
                            throw new Error('Tenant bilgisi alınamadı')
                        }
                        
                        const data = await response.json()
                        
                        if (data.tenant) {
                            this.tenant = data.tenant
                            localStorage.setItem('tenant', JSON.stringify(data.tenant))
                            Logger.info('Tenant bilgisi başarıyla alındı ve kaydedildi')
                            return true
                        }
                        return false
                    } catch (error) {
                        Logger.error('Tenant bilgisi alınamadı:', error)
                        return false
                    }
                },


        async initAuth() {
            Logger.group('Auth Durumu Kontrolü')
            const accessToken = Cookies.get('accessToken')
            const refreshToken = Cookies.get('refreshToken')
            const userStr = localStorage.getItem('user')
            const tenantStr = localStorage.getItem('tenant')
            const allowedLinksStr = localStorage.getItem('allowedLinks')

            if (accessToken && refreshToken && userStr) {
                try {
                    const remainingTime = this.getTokenRemainingTime(accessToken)
                    
                    if (remainingTime <= 0) {
                        Logger.log('Token süresi dolmuş, yenileniyor...')
                        await this.refreshTokens()
                        return false
                    }

                    Logger.log('Token ve kullanıcı bilgileri bulundu')
                    
                    const user = JSON.parse(userStr)
                    this.accessToken = accessToken
                    this.refreshToken = refreshToken
                    this.user = user
                    this.allowedLinks = allowedLinksStr ? JSON.parse(allowedLinksStr) : []
                    
                    // Tenant varsa yükle, yoksa backend'den al
                    if (tenantStr) {
                        this.tenant = JSON.parse(tenantStr)
                        Logger.log('Tenant bilgisi localStorage\'dan yüklendi')
                    } else {
                        Logger.warn('Tenant bilgisi bulunamadı, backend\'den alınıyor...')
                        await this.fetchTenantInfo()
                    }

                    this.lastTokenRefresh = new Date()
                    this.startTokenRefreshInterval()

                    Logger.log('Auth durumu başarıyla yüklendi')
                    Logger.groupEnd()
                    return true
                } catch (error) {
                    Logger.error('Auth init hatası:', error)
                    this.logout()
                    return false
                }
            }

            Logger.log('Token veya kullanıcı bilgileri eksik')
            Logger.groupEnd()
            
            if (router.currentRoute.value.meta.requiresAuth) {
                router.push('/auth/login')
            }
            
            return false
        },

    async sendVerificationEmail() {
        this.login_error = false
        this.save_loading = true
        
        try {
            await axios_public.post(
                `${sabitler.apiBaseURL}rest-auth/registration/resend-email/`,
                { email: this.pendingUserEmail }  // 🆕 pendingUserEmail kullan
            )
            Logger.info('Doğrulama emaili gönderildi')
            this.login_error = 'Email adresinize doğrulama linki gönderildi'
            return true
        } catch (error: any) {
            Logger.error('Email gönderme hatası:', error)
            this.login_error = error.response?.data?.detail || 'Email gönderilemedi'
            return false
        } finally {
            this.save_loading = false
        }
    },

async addPhoneAndSendOTP(phone: string) {
    this.login_error = false
    this.save_loading = true
    
    try {
        const response = await axios_public.post(
            `${sabitler.apiBaseURL}v1/users/add-phone-for-verification/`,
            {
                user_id: this.pendingUserId,
                phone: phone
            }
        )
        
        this.newPhoneNumber = phone
        this.pendingUserPhone = phone
        this.referenceId = response.data.ref_id
        this.verifyStep = 'phone'
        Logger.info('Telefon eklendi ve OTP gönderildi')
        return true
    } catch (error: any) {
        Logger.error('Telefon ekleme hatası:', error)
        this.login_error = error.response?.data?.detail || 'Telefon eklenemedi'
        return false
    } finally {
        this.save_loading = false
    }
},

async sendPhoneOTP() {
    this.login_error = false
    this.save_loading = true
    
    try {
        const response = await axios_public.post(
            `${sabitler.apiBaseURL}v1/users/verify-phone/send-otp/`,
            { 
                user_id: this.pendingUserId,
                phone: this.pendingUserPhone
            }
        )
        
        this.referenceId = response.data.ref_id
        this.verifyStep = 'phone'
        Logger.info('OTP gönderildi')
        return true
    } catch (error: any) {
        Logger.error('OTP gönderme hatası:', error)
        this.login_error = error.response?.data?.detail || 'OTP gönderilemedi'
        return false
    } finally {
        this.save_loading = false
    }
},

async verifyPhoneOTP(code: string) {
    this.login_error = false
    this.save_loading = true
    
    try {
        await axios_public.post(
            `${sabitler.apiBaseURL}v1/users/verify-phone/confirm-otp/`,
            {
                ref_id: this.referenceId,
                otp: code
            }
        )
        
        this.phoneVerified = true
        
        // 🔥 Her zaman required ekranına dön
        this.verifyStep = 'required'
        Logger.info('Telefon doğrulandı')
        
        // 🔥 Başarı mesajı
        this.login_error = 'Telefon doğrulandı! Email doğrulaması da tamamlandıysa giriş yapabilirsiniz.'
        
        // 🔥 Login yönlendirmesi KALDIRILDI
        // if (this.emailVerified && this.phoneVerified) {
        //     this.verifyStep = 'complete'
        //     router.push('/auth/login')
        // }
        
        return true
    } catch (error: any) {
        Logger.error('OTP doğrulama hatası:', error)
        this.login_error = error.response?.data?.detail || 'Kod hatalı'
        return false
    } finally {
        this.save_loading = false
    }
},

    resetVerifyState() {
        this.verifyStep = 'none'
        this.pendingUserId = null
        this.pendingUserEmail = null
        this.pendingUserPhone = null
        this.newPhoneNumber = null
        this.emailVerified = false
        this.phoneVerified = false
        this.referenceId = null
    }
    },
})